module.exports = __webpack_public_path__ + "img/breadcrumb1.70f7828d.png";